import {Input} from 'antd';

type PropsType = {
    maxLength: number;
    value?: string;
    onChange?: (value: string) => void;
};

// Single-line title field rendered as a one-row TextArea so its character counter uses Ant's
// native show-count element — identical in size and offset to the multiline description counter.
// Enter is suppressed and newlines are stripped so the value stays a clean single-line title.
export function PublicationTitleInput({maxLength, value, onChange}: PropsType): JSX.Element {
    return (
        <Input.TextArea
            autoSize={{maxRows: 1, minRows: 1}}
            maxLength={maxLength}
            onChange={(event) => onChange?.(event.target.value.replace(/\n/g, ''))}
            onKeyDown={(event) => {
                if (event.key === 'Enter') {
                    event.preventDefault();
                }
            }}
            showCount
            value={value ?? ''}
        />
    );
}
